
const CACHE_DURATION = 12 * 60 * 60 * 1000; // 12 hours in milliseconds

interface CachedData<T> {
  timestamp: number;
  data: T;
}

export function getCached<T>(key: string): T | null {
  const cached = localStorage.getItem(key);
  if (!cached) return null;

  const { timestamp, data } = JSON.parse(cached) as CachedData<T>;

  if (Date.now() - timestamp < CACHE_DURATION) {
    return data;
  }

  return null;
}

export function setCached<T>(key: string, data: T) {
  const cachedData: CachedData<T> = {
    timestamp: Date.now(),
    data,
  };
  localStorage.setItem(key, JSON.stringify(cachedData));
}
